module.exports = __webpack_public_path__ + "static/media/couponSample.96865ffb.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/feature/dPay/couponSample.jpg
 ** module id = 591
 ** module chunks = 0
 **/